import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AcheelTarificationRequest, AcheelTarificationResponse } from '../models/deuxma.model';
import { environment } from '../environments/environmentCAS';

@Injectable({
  providedIn: 'root'
})
export class DeuxMaService {

  private apiUrl = `${environment.casApiUrl}${environment.endpoints.deuxma.acheel.replace('/acheel', '')}`; // L'URL de base de votre API backend

  constructor(private http: HttpClient) { }

  getAcheelTarif(request: AcheelTarificationRequest): Observable<AcheelTarificationResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<AcheelTarificationResponse>(`${this.apiUrl}/acheel`, request, { headers });
  }

  /**
   * Envoie la requête de tarification 2MA (Deuxmaltitude) au backend
   * URL configurée dans environmentCAS.ts (deuxmaltitude)
   * @param request Payload formaté pour 2Maltitude
   * @returns Observable de la réponse (tarifs 2MA)
   */
  get2MaltitudeTarif(request: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    const url = `${environment.casApiUrl}${environment.endpoints.deuxma.deuxmaltitude}`;
    return this.http.post<any>(url, request, { headers });
  }
}
